import React from "react";
import '../../src/index.css';
import { Redirect, Route, Switch } from "react-router-dom";
import { customerAuthorizationsSearchFilters, receivedApplicationSearchFilters, sentApplicationsSearchFilters, organizationSearchFilters, authorizedUsersSearchFilters } from "../framework/configuration/selectValues";
import { ViewType } from "../page/enums/ViewType";
import ApplicationSelectView from "../page/ApplicationSelectView";
import TableView from "../page/TableView";
import { useSelector } from "react-redux";
import { getOrganizationsInitialized } from "../features/basic/reducers/basicReducer";
import styled from "styled-components";
import CreateApplicationView from "../page/CreateApplicationView ";
import LinkEnterpriseView from "../page/LinkEnterpriseView";
import { useTheme } from "../features/context/CustomerContext";
import LoadingSpinner from "../framework/components/loadingSpinner/LoadingSpinner";
import { PrivateRoute } from "./PrivateRoute";

const LoadingContainer = styled.div`
    @media screen and (min-width: ${(props) => props.theme.mobileTableBreakPoint}px) {
        width:1035px; 
        margin: 60px auto 60px auto;
    }
    @media screen and (min-width: 1550px) {
        width: auto;
        margin: 60px 250px 60px 250px;
    }
    background: white;
    height: 530px;
    border-radius: 20px;
    border-bottom-left-radius: 10px;
    display: flex;
`

const AppRouter: React.FC = () => {
    const theme = useTheme();

    const showInfoText = localStorage.getItem('infoTextAlreadyDisplayed') ? false : true;
    const organizationsInitialized= useSelector(getOrganizationsInitialized);

    if (!organizationsInitialized) {
        return (
            <LoadingContainer theme={theme}>
                <LoadingSpinner/>
            </LoadingContainer>
        )
    }

    return (
        <Switch>
            <PrivateRoute path="/authorizedUsers">
                <TableView type={ViewType.AUTHORIZED_USERS} searchFilters={authorizedUsersSearchFilters} showInfo={showInfoText}/>
            </PrivateRoute>
            <Route path="/customerAuthorizations" >
                <TableView type={ViewType.CUSTOMER_AUTHORIZATIONS} searchFilters={customerAuthorizationsSearchFilters} showInfo={showInfoText}/>
            </Route>
            <Route path="/receivedApplications" >
                <TableView type={ViewType.RECEIVED_APPLICATIONS} searchFilters={receivedApplicationSearchFilters} showInfo={showInfoText}/>
            </Route>
            <Route path="/sentApplications" >
                <TableView type={ViewType.SENT_APPLICATIONS} searchFilters={sentApplicationsSearchFilters} showInfo={showInfoText}/>
            </Route>
            <PrivateRoute path="/organizations" >
                <TableView type={ViewType.ORGANIZATIONS} searchFilters={organizationSearchFilters} showInfo={showInfoText}/>
            </PrivateRoute>
            <Route path="/linkEnterprise" >
                <LinkEnterpriseView />
            </Route>
            <Route path="/selectApplicationType" >
                <ApplicationSelectView />
            </Route>
            <Route path="/createApplication" >
                <CreateApplicationView />
            </Route>
            <Redirect to="/sentApplications" />
        </Switch>
    );
}

export default AppRouter;